import { render, staticRenderFns } from "./painel_gestor_config.vue?vue&type=template&id=ef1d86d8"
import script from "./painel_gestor_config.vue?vue&type=script&lang=js"
export * from "./painel_gestor_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports